import * as React from 'react';
//import { useDrop, useDrag, DropTargetMonitor } from 'react-dnd'
//import { XYCoord } from 'dnd-core';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';
//import DragableIcon from '@mui/icons-material/DragHandle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';
import { ViewPropertyExtended } from '../../../../../sic-lib/types/ViewProperty';

/*
 * DRAG & DROP DISABLED DUE TO BUGS
 *
 * React-Dnd draggable component
 * https://react-dnd.github.io/react-dnd/about
 *
 * follows example of "simple sortable" list
 * https://react-dnd.github.io/react-dnd/examples/sortable/simple
 */

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        padding: theme.spacing(1),
    },
    //dragIcon: {
    //    [theme.breakpoints.up(0)]: {
    //        display: 'none'
    //    },
    //    [theme.breakpoints.up('lg')]: {
    //        display: 'inline-block',
    //        flexBasis: '48px',
    //        flexGrow: 0,
    //        maxWidth: '48px'
    //    }
    //},
    iconButton: {
        [theme.breakpoints.up(0)]: {
            padding: '4px',
        },
        [theme.breakpoints.up('md')]: {
            padding: '8px',
            maxWidth: '56px',
        },
    },
    text: {
        [theme.breakpoints.up(0)]: {
            /* buttons: 48px * 3 */
            maxWidth: 'calc(100% - 144px)',
        },
        [theme.breakpoints.up('md')]: {
            /* buttons: 56px * 3 */
            maxWidth: 'calc(100% - 168px)',
        },
    },
}));

//const ItemTypes = {
//    card: 'Card'
//}

//interface DragItem {
//    index: number;
//    id: number;
//    type: string;
//}

type Props = {
    config: ViewPropertyExtended;
    index: number;
    onReorderHandler: (endIndex: number, startIndex: number) => void;
    onRemoveHandler: (fieldId: number) => void;
};

export default function DraggableViewProperty({
    config,
    index,
    onReorderHandler,
    onRemoveHandler,
}: Props) {
    const { classes } = useStyles();

    //const ref = React.useRef<HTMLLIElement | null>(null);

    //const [, drop] = useDrop({
    //    accept: ItemTypes.card,
    //    hover(item: DragItem, monitor: DropTargetMonitor) {
    //        if (!ref.current) return;

    //        const dragIndex = item.index;
    //        const hoverIndex = index;

    //        if (dragIndex == hoverIndex) return;

    //        // get rectangle on screen
    //        const hoverBoundingRect = ref.current?.getBoundingClientRect();

    //        // get vertical middle
    //        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    //        // get mouse position
    //        const clientOffset = monitor.getClientOffset();

    //        // get pixels to the top
    //        const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

    //        // goal: perform move only when drag element has gone past 50% height of object above/ below
    //        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return; //~ drag down
    //        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return; //~ drag up

    //        onReorderHandler(hoverIndex, dragIndex); //!! called everytime an object changes position during hover; investigate 'end' in useDrag hook

    //        item.index = hoverIndex;
    //    }
    //});

    //const [{ isDragging }, drag] = useDrag({
    //    item: { type: ItemTypes.card, id: config.fieldId, index },
    //    collect: (monitor: any) => {
    //        return { isDragging: monitor.isDragging() }
    //    }
    //});

    //drag(drop(ref));

    const handleRemove = () => {
        onRemoveHandler(config.fieldId);
    };

    const handleClickReorder = (event: React.MouseEvent<HTMLButtonElement>) => {
        const { direction } = event.currentTarget.dataset;

        if (direction) {
            onReorderHandler(index + parseInt(direction), index);
        }
    };

    return (
        <li className={classes.root}>
            <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={2}>
                <Grid item xs={true} className={classes.text}>
                    <Typography variant="body1" noWrap>
                        {config.label}
                    </Typography>
                </Grid>
                <Grid item xs="auto">
                    <Tooltip title="Shift up">
                        <IconButton
                            data-direction="-1"
                            onClick={handleClickReorder}
                            className={classes.iconButton}
                            size="large"
                        >
                            <ArrowDropUpIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs="auto">
                    <Tooltip title="Shift down">
                        <IconButton
                            data-direction="1"
                            onClick={handleClickReorder}
                            className={classes.iconButton}
                            size="large"
                        >
                            <ArrowDropDownIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs="auto">
                    <Tooltip title="Remove">
                        <IconButton
                            onClick={handleRemove}
                            className={classes.iconButton}
                            size="large"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </li>
    );
}

//<Grid item className={classes.dragIcon}>
//    <DragableIcon />
//</Grid>
